'use strict'
import axios from 'axios'
// import store from '@/store'
// import router from '@/router'
import bus from './bus.js'
// import { getToken, getTenant } from '@/utils/auth'
// import { sysAppId, isLocal } from '@/settings.js'

import qs from 'qs'
const {API_ROOT} = require('../../static/config.js')

// 处理请求数据 9101
const whiteList = [
  '/connect/token',
  '/api/identity/my-profile', // 获取用户信息
  '/api/Jwt/RefreshAccessToken', // 更新token
  '/api/map-tenancy/hybrid-map-tenants/search'// 获取租户
]
const qsUrl = ['/connect/token']

axios.interceptors.request.use(
  config => {
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // =========================================================
    // 请求拦截
    // const isToken = (config.headers || {}).isToken === false
    // let token = getToken() ? getToken() : ''
    // if (token && !isToken) {
    //   config.headers['Authorization'] = 'Bearer ' + token
    // //   config.headers['sysappid'] = sysAppId
    // }
    if (config.headers['Content-Type'] !== 'application/x-www-form-urlencoded' && qsUrl.indexOf(config.url) >= 0) {
      if (config.method === 'post' || config.method === 'POST') {
        config.data = qs.stringify(config.data)
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    // 响应拦截
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

function getData (val, url) {
  // 处理请求数据
  /* const whiteList = [
      "/login",

    ] */
  // 判断登录用户信息/权限
  if (whiteList.join(',').indexOf(url) >= 0) {
    // 密码登录：登录    手机登录：获取验证码、登录
    return val
  } else {
    // if (!isLocal) {
    //   const token = getToken() ? getToken() : ''
    //   if (!token) {
    //     bus.$message.warning('用户令牌失效,请重新登录~')
    //     setTimeout(async () => {
    //       await store.dispatch('user/logout')
    //       router.push('/login')
    //     }, 100)
    //   }
    // }
  }
  if (typeof val === 'string') {
    return JSON.parse(val)
  } else {
    return val
  }
}
// 请求参数
function getOptions (url, method, data, params, queryAndBody) {
  let flag = false
  for (let i = 0; i < whiteList.length; i++) {
    if (url.indexOf(whiteList[i]) !== -1) {
      flag = true
      break
    }
  }
  // eslint-disable-next-line no-unused-vars
  const _url = flag ? window.g.API_ROOT_LOGIN : API_ROOT
  const options = {
    method: method,
    baseURL: API_ROOT, // _url
    url: url,
    timeout: 10000,
    headers: {}
  }
  if (queryAndBody) {
    const paramsData = data
    const bodyObject = paramsData.bodyObject
    delete paramsData.bodyObject
    options.headers['Content-Type'] = 'application/json;charset=UTF-8'
    options.params = getData(paramsData, url)
    options.data = getData(bodyObject, url)
  } else {
    const pd = !params ? 'data' : 'params'
    options[pd] = getData(data, url)
  }

  return options
}

// eslint-disable-next-line no-unused-vars
function checkStatus (response) {
  // 处理响应数据
  if (response && (response.status === 200 || response.status === 204)) {
    // loading,如果http状态码正常，则直接返回数据
    let res = response.data
    if (!res) {
      bus.$message.error('服务器开了个小差')
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    }
    if (res.statusCode === 200 || res.statusCode === 204) {
      return res.data
    } else {
      if (res.errors) {
        bus.$message.error(res.errors)
      }
      return Promise.reject(res)
    }
  } else {
    if (response.data.error && !response.data.error.code) {
      bus.$message.error(response.data.error.message)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(false)
    } else {
      return Promise.reject(response.data)
    }
  }
}

function checkCode (_error) {
  bus.$message.error('网络异常~')
}

export default {
  async post (url, data, query, queryAndBody) {
    const options = getOptions(url, 'post', data, query, queryAndBody)
    return new Promise((resolve, reject) => {
      axios(options)
        .then(response => {
          resolve(checkStatus(response))
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  async postForm (url, data) {
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    const options = {
      method: 'post',
      baseURL: API_ROOT,
      url: url,
      timeout: window.g.AXIOS_TIMEOUT ? window.g.AXIOS_TIMEOUT : 10000,
      headers: {
        'Content-Type': 'multipart/form-data;'
      },
      data: data
    }
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  async get (url, data, query) {
    const options = getOptions(url, 'get', data, query)
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  async put (url, data, query, queryAndBody) {
    const options = getOptions(url, 'put', data, query, queryAndBody)
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  },
  async delete (url, data) {
    const options = getOptions(url, 'delete', data, 'query')
    return axios(options)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/api/http.js
// module id = null
// module chunks = 